import { render, staticRenderFns } from "./proposal-tab-jobs.vue?vue&type=template&id=2bd63f52"
import script from "./proposal-tab-jobs.vue?vue&type=script&lang=js"
export * from "./proposal-tab-jobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports